import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SupportTicketMessage } from '../../../../shared/interfaces';

/** Conversation of a support ticket, oldest first */
@Component({
  selector: 'app-support-thread',
  imports: [DatePipe],
  templateUrl: './support-thread.html',
  styleUrl: './support-thread.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupportThread {
  @Input() messages: SupportTicketMessage[] = [];
  @Input() loading = false;
  /**
   * Who is reading. The ticket owner sees their messages as "Tú"; support sees every
   * author by name, since several admins may answer the same ticket.
   */
  @Input() viewer: 'user' | 'support' = 'user';
  @Input() emptyText = 'Aún no hay mensajes.';

  isOwn(message: SupportTicketMessage): boolean {
    return this.viewer === 'user' && message.authorRole === 'user';
  }

  authorLabel(message: SupportTicketMessage): string {
    if (this.isOwn(message)) return 'Tú';
    return message.authorName || (message.authorRole === 'support' ? 'Soporte' : 'Usuario');
  }
}
